import React from "react";

const LogoutButton = () => {
  const handleLogout = () => {
    // ✅ Clear everything from localStorage & sessionStorage
    localStorage.clear();
   // sessionStorage.clear();

    // ✅ Redirect to login page
    window.location.href = "/login";
  };

  return (
    <button
      onClick={handleLogout}
      style={{
        padding: "10px 20px",
        fontSize: "15px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        background: "#e74c3c",
        color: "white",
        fontWeight: "bold",
        position: "absolute",
        top: "20px",
        right: "20px",
      }}
    >
      🔒 Logout
    </button>
  );
};

export default LogoutButton;
